import { Box, Alert } from '@mui/material'

const MSTeams = ({ enterprise }) => {
    if (! enterprise?.platforms?.msteams) {
        return (
            <Box>
                <Alert severity="info">
                    Entre em contato com seu gerente de contas para contratar o canal Microsoft Teams - <a href="https://wa.link/0bs73j">Clique aqui.</a>
                </Alert>
            </Box>
        )
    }
    return null
}

export default MSTeams